/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2023-02-25 11:03:06
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-25 11:03:32
 * @FilePath: /wecalendar-web-component/packages/pc-biz/src/quickServices/PublicCouponQueryPublicList.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
// import http from '@lib/http';
// import { GetServerSidePropsContext } from 'next';

const PublicCouponQueryPublicList = async (data, http) => {
  // @ts-ignore
  const res = await http.post('/wemeet-tapi', '/v2/activities/public/coupon/query-public-list', data);
  return res;
};
export default PublicCouponQueryPublicList;